import { BLOCK_DATE_LIST, BLOCK_DATE_LIST_SUCCESS, BLOCK_DATE_LIST_ERROR, BLOCK_DATE_LIST_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const BlockedDatesList = (state = initialState, action) => {
  switch (action.type) {
    case BLOCK_DATE_LIST:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case BLOCK_DATE_LIST_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case BLOCK_DATE_LIST_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case BLOCK_DATE_LIST_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default BlockedDatesList;
